// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="securityCreatedConfirmationTitle">Registration Complete</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="securityCreatedConfirmationBody">Thank you for registering with Property Pay.</p>
            <p tid="securityCreatedConfirmationBody">For your security, please log in to make a payment.</p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--blue Button--minWidth130"
                    (click)="closeThisDialog(0)"
                    tid="securityConfirmationContinueButton">
                Continue
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;